import React from 'react';
import SitesSettingPage from '../SitesSettingPage';

const SiteManagementPage: React.FC = () => {
    return <SitesSettingPage />;
};

export default SiteManagementPage;
